import { render, staticRenderFns } from "./CredentialImplementSave.vue?vue&type=template&id=f8c37b36&scoped=true&"
import script from "./CredentialImplementSave.vue?vue&type=script&lang=js&"
export * from "./CredentialImplementSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c37b36",
  null
  
)

export default component.exports